module.exports = __webpack_public_path__ + "static/media/celular.a1be359d.svg";